import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const Magnifier = withDefaultIconProps({ height: 25, width: 25 }, ({ color, ...rest }) => (
  <Svg {...rest} viewBox="0 0 25 25">
    <Path
      d="M13.67 15.17L19.27 20.77C19.39 20.89 19.54 20.95 19.7 20.95C19.86 20.95 20.01 20.89 20.13 20.77L20.93 19.97C21.17 19.73 21.17 19.34 20.93 19.1L15.33 13.5C15.22 13.39 15.06 13.32 14.9 13.32H14.11C15.02 12.27 15.51 10.94 15.51 9.53C15.51 7.98 14.91 6.52 13.81 5.43C12.71 4.33 11.25 3.72 9.7 3.72C8.15 3.72 6.69 4.33 5.59 5.43C4.49 6.52 3.89 7.98 3.89 9.53C3.89 11.09 4.49 12.55 5.59 13.64C6.69 14.74 8.15 15.35 9.7 15.35C11.11 15.35 12.44 14.85 13.49 13.94V14.73C13.49 14.9 13.55 15.05 13.67 15.17V15.17ZM9.7 14.12C7.17 14.12 5.11 12.06 5.11 9.53C5.11 7 7.17 4.95 9.7 4.95C12.23 4.95 14.29 7 14.29 9.53C14.29 12.06 12.23 14.12 9.7 14.12V14.12Z"
      fill={color}
    />
  </Svg>
));
